query getAirdropBonus($eth_address: String, $start_date: String, $end_date: String, $filter: String) {
    getAirdropBonus(eth_address: $eth_address, start_date: $start_date, end_date: $end_date, filter: $filter) 
}
